import { Menu, MenuProps } from "@mui/material";
import { cloneElement, Fragment, ReactElement, ReactNode, SyntheticEvent, useState } from "react";

import MoreButton from "./Buttons/MoreButton";

export type CloseMenuType = (e?: SyntheticEvent) => void;

export type SimpleMenuPropsType = {
  button?: ReactElement;
  children: (closeMenu: CloseMenuType) => ReactNode | ReactNode[];
  onButtonClick?: () => void;
  buttonSize?: "small" | "medium" | "large";
} & Omit<MenuProps, "open" | "children">;

export default function SimpleMenu(props: SimpleMenuPropsType) {
  const { button, children, onButtonClick, buttonSize = "medium", ...rest } = props;
  const [menuAnchorElement, setMenuAnchorElement] = useState<Element | null>(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const closeMenu = (e?: { stopPropagation?: () => void; preventDefault?: () => void }) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setMenuIsOpen(false);
  };

  const toggleMenu = (e: SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setMenuAnchorElement(e.currentTarget);
    setMenuIsOpen(!menuIsOpen);
    onButtonClick?.();
  };

  return (
    <Fragment>
      {button && cloneElement(button as ReactElement<{ onClick: typeof toggleMenu }>, { onClick: toggleMenu })}
      {!button && <MoreButton onClick={toggleMenu} size={buttonSize} />}

      <Menu anchorEl={menuAnchorElement} open={menuIsOpen} onClose={closeMenu} keepMounted {...rest}>
        {children(closeMenu)}
      </Menu>
    </Fragment>
  );
}
